// extracted by mini-css-extract-plugin
export default {"toDefault":"DefaultButton_toDefault__Pzapr"};